module.exports = __webpack_public_path__ + "media/images/bsmart/icons/report_insufficiente-5e5c889d3095d47ca759de799b475364.svg";